import React, { useContext } from 'react'
import { ethers } from 'ethers'
import WalletContext from '../pages/walletContext'
import { Row, Col, Form, Input, Button, Checkbox, Select } from 'antd'
import { abi, contractAddress } from '../config/contract'
// import { claimTokens } from '../functions/claimTokens'
import { handleChangeRequest } from '../functions/handleWalletChange'
import { useTokenCalculation } from '../functions/tokenCalculation'
// import { privateSaleDetails } from '../functions/privateSaleInfo'
import { publicSaleDetails } from '../functions/publicSaleInfo'

import SamLogo from '../assets/Sam_logo 1.png'
import DollarImage from '../assets/dollar-sign 1.png'
import BitImage from '../assets/image 5.png'
import EthImage from '../assets/image 6.png'
import WalletImage from '../assets/wallet 1.png'

const cardData = [
  {
    image: DollarImage,
    value: '0 USD',
  },
  {
    image: BitImage,
    value: '0 BTC',
  },
  {
    image: EthImage,
    value: '0 ETH',
  },
]

const CustomForm = () => {
  const [samsTokens, maticAmountInUSD, handleAmountChange] = useTokenCalculation()
  const context = useContext(WalletContext)
  const { Option } = Select

  const { userPublicSaleBalance, publicSaleCount } = publicSaleDetails(
    contractAddress,
    abi,
    context,
  )

  const onFinish = async (values) => {
    console.log('Enter:', values)
    try {
      // Convert amount to Wei
      const amountInWei = ethers.parseEther(values.amountInCrypto)
      console.log(amountInWei.toString())
      // Set the contract
      const provider = new ethers.BrowserProvider(window?.ethereum)
      const signer = await provider.getSigner()

      const contract = new ethers.Contract(contractAddress, abi, signer)

      // Execute the publicSaletransfer function
      const tx = await contract.publicSaletransfer({ value: amountInWei })
      await tx.wait()
      console.log('Transaction successful!')
    } catch (error) {
      console.error('Error:', error)
    }
  }

  // window?.ethereum?.on('chainChanged', () => {
  //   // Handle the network change
  //   // This could involve resetting the user's state, reloading the page, etc.
  //   window.location.reload()
  // })

  window?.ethereum?.on('accountsChanged', async (accounts) => {
    try {
      const provider = new ethers.BrowserProvider(window?.ethereum)
      const newAddress = accounts[0]
      const walletBalance = await provider.getBalance(newAddress)
      context.setAddress(newAddress)
      context.setBalance(ethers.formatEther(walletBalance))
    } catch (error) {
      console.log('Error:', error)
    }
  })

  const CardComp = ({ image, value }) => {
    return (
      <div className='card-1'>
        <img src={image} />
        <p>{value}</p>
      </div>
    )
  }
  return (
    <div className='buy-token-page'>
      <div className='content'>
        <Row gutter={[30, 20]}>
          <Col md={15} xs={24}>
            <div className='border-box'>
              <Form
                className='token-form'
                name='basic'
                layout='vertical'
                onFinish={onFinish}
                autoComplete='off'
              >
                <Form.Item
                  label='Select Cryptocurrency'
                  name='currencyType'
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please select currency type',
                  //   },
                  // ]}
                  requiredMark={'optional'}
                >
                  <Select
                    className='token-form-select'
                    placeholder='Choose Cryptocurrency'
                    allowClear
                  >
                    <Option value='currency-1'>SAMS</Option>
                  </Select>
                </Form.Item>

                {/* <Form.Item
                  label='Enter Amount in USD'
                  name='amount'
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Enter Amount',
                  //   },
                  // ]}
                  requiredMark={'optional'}
                >
                  <Input className='token-form-input' placeholder='Amount (USD)' />
                </Form.Item> */}

                <Form.Item
                  label='Enter Amount in Native Crypto'
                  name='amountInCrypto'
                  rules={[
                    {
                      required: true,
                      message: 'Enter Amount in Native Crypto',
                    },
                  ]}
                  requiredMark={'optional'}
                >
                  <Input
                    className='token-form-input'
                    placeholder='Amount in Matic'
                    onChange={handleAmountChange}
                  />
                </Form.Item>

                <h2>USD equivalent of SAMS: {maticAmountInUSD}</h2>

                <Form.Item
                  label='Total $SAMS Tokens you will receive'
                  name='samsToken'
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Enter SAMS token',
                  //   },
                  // ]}
                  requiredMark={'optional'}
                >
                  <Input className='token-form-input' placeholder={samsTokens} disabled />
                </Form.Item>

                <Form.Item
                  name='agreement'
                  valuePropName='checked'
                  rules={[
                    {
                      required: true,
                      message: 'Check Policy',
                    },
                  ]}
                  requiredMark={'optional'}
                >
                  <Checkbox>
                    <p>
                      I read and agree to the{' '}
                      <span style={{ color: '#289FC9' }}>token purchase agreement</span> and{' '}
                      <span style={{ color: '#289FC9' }}>privacy policy</span>.
                    </p>
                  </Checkbox>
                </Form.Item>

                <Form.Item>
                  <Button type='primary' htmlType='submit'>
                    Make Purchase
                  </Button>
                </Form.Item>

                {/* <Form.Item>
                  <Button type='primary' onClick={claimTokens}>
                    Claim Tokens
                  </Button>
                </Form.Item> */}
              </Form>

              <p>
                <span style={{ color: '#F44949' }}>IMPORTANT NOTE</span>: Token is available on
                Polygon Chain. Make sure your wallet is connected to Polygon mainnet. If your
                balance is not updated on the dashboard, please refresh this page.{' '}
              </p>
            </div>
          </Col>
          <Col md={9} xs={24}>
            <div className='right-comp'>
              <div className='header'>
                <div className='left'>
                  <p className='label'>Token balance</p>
                  <p className='balance'>{context.balance}</p>
                </div>
                <img src={SamLogo} />
              </div>

              <h2>
                Your Public Sale Balance:<span>{userPublicSaleBalance} SAMS</span>{' '}
              </h2>
              <h2>
                Total Public Sales Count:<span> {publicSaleCount}</span>
              </h2>

              <div className='middle-sec'>
                <p className='label'>Your Contibution in:</p>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    columnGap: '1.5rem',
                    rowGap: '10px',
                    flexWrap: 'wrap',
                    marginTop: '1rem',
                  }}
                >
                  {cardData?.map((item, index) => (
                    <CardComp key={index} image={item?.image} value={item?.value} />
                  ))}
                </div>
              </div>

              <div className='bottom-sec'>
                <img src={WalletImage} />
                <p className='label'>Your Receiving Wallet</p>
                <div className='number'>{context.address}</div>
                <Button type='primary' onClick={handleChangeRequest}>
                  Request For Change
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default CustomForm
